module.exports = __webpack_public_path__ + "static/img/Keanu-Baccus.c536357.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Keanu-Baccus.jpg
// module id = d1J+
// module chunks = 0